import axiosInstance from "../../utils/AxiosInstance";
import { toast } from "react-toastify";
import { useAuthHeader, useAuthUser, useIsAuthenticated } from "react-auth-kit";
import { useMutation, useQuery, useQueryClient } from "react-query";

// GET /notifications
export const useGetNotifications = (all) => {
  const isAuthenticated = useIsAuthenticated();
  const authHeader = useAuthHeader();
  const authUser = useAuthUser();
  const refetchSeconds = 90;

  return useQuery({
    queryKey: all ? ["notifications", "all"] : ["notifications"],
    queryFn: async () => {
      const res = await axiosInstance.get(
        `/notifications${all ? "?all=True" : ""}`,
        {
          headers: { Authorization: authHeader() },
        }
      );
      return res === undefined ? null : res.data;
    },
    refetchInterval: 1000 * refetchSeconds,
    enabled: isAuthenticated(), // && authUser()?.role !== 3,
  });
};

// === PUT /notifications ===
export const useSetNotificationRead = () => {
  const authHeader = useAuthHeader();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (notification_id) => {
      const res = await axiosInstance.put(
        `/notifications`,
        {
          ids: [notification_id],
        },
        {
          headers: { Authorization: authHeader() },
        }
      );
      return res.data;
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(["notifications"]);
    },
    onError: (data, variables, context) => {},
  });
};
